import React, { Component } from "react";

//Components
import About from "./about/About";
import Skills from "./skills/Skills";
import Education from "./education/Education";
import Experience from "./experience/Experience";
import Contact from "./contact/Contact";

class Profile extends Component {
	render() {
		return (
			<React.Fragment>
				<About />
				<Skills />
				<Education/>
				<Experience/>
				<Contact/>
			</React.Fragment>
		);
	}
}

export default Profile;
